// extracted by mini-css-extract-plugin
export default {"container":"_1O5dKpbGuk6pDzAXnbmg0O","name":"_6t9erry3jRre02B8SLm6wU"};